import { SelectionMetaEvent } from './internal';
export class SelectionCitationEvent extends SelectionMetaEvent {
    getRole() {
        return this.get("ROLE" /* Tag.Role */);
    }
}
//# sourceMappingURL=SelectionCitationEvent.js.map